import React from 'react';
import { downloadFile } from '../../downloadFile';
import { GreyLink, GreyText } from './styles';
const newTabExtensions = ['jpeg', 'jpg', 'png', 'pdf'];
export default function FileTitle({
  file,
  setPath
}) {
  const {
    extension,
    link,
    name
  } = file;
  const openFolder = () => {
    setPath(file.path);
  };
  const openFile = () => {
    if (newTabExtensions.includes(extension)) {
      window.open(link, '_blank', 'noopener,noreferrer');
    } else {
      downloadFile(link);
    }
  };
  return extension === 'folder' ? <GreyLink data-testid="archive-title-doc" onClick={openFolder}>
      {name}
    </GreyLink> : <GreyText onClick={openFile}>{name}</GreyText>;
}